<div class="container-fluid py-3">
  <div class="row">

    <div class="col-12 mb-3">
      <h4><b>Bitácora de servicios externos</b></h4>
    </div>

    <!-- Filtros -->
    <div class="col-12 bg-white rounded-3 shadow-sm p-3 mb-3">
      <div class="row align-items-end g-2">

        <div class="col-12 col-md-3 col-xl-2">
          <label class="form-label text-secondary fw-500"
            style="font-size: calc(0.65rem + 0.45vh);">
            Servicio
          </label>
          <ng-select
            [items]="serviceOptions"
            bindLabel="label"
            bindValue="value"
            [(ngModel)]="filterService"
            [clearable]="true"
            placeholder="Todos">
          </ng-select>
        </div>

        <div class="col-12 col-md-3 col-xl-2">
          <label
            class="form-label text-secondary fw-500"
            style="font-size: calc(0.65rem + 0.45vh);">
            Dirección
          </label>
          <ng-select
            [items]="directionOptions"
            bindLabel="label"
            bindValue="value"
            [(ngModel)]="filterDirection"
            [clearable]="true"
            placeholder="Todas">
          </ng-select>
        </div>

        <div class="col-12 col-md-3 col-xl-2">
          <label
            class="form-label text-secondary fw-500"
            style="font-size: calc(0.65rem + 0.45vh);">
            Resultado
          </label>
          <ng-select
            [items]="successOptions"
            bindLabel="label"
            bindValue="value"
            [(ngModel)]="filterSuccess"
            [clearable]="true"
            placeholder="Todos">
          </ng-select>
        </div>

        <div class="col-12 col-md-3 col-xl-2">
          <label
            class="form-label text-secondary fw-500"
            style="font-size: calc(0.65rem + 0.45vh);">
            Desde
          </label>
          <p-calendar
            [(ngModel)]="filterStartDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [showClear]="true"
            placeholder="Fecha inicio"
            styleClass="w-100">
          </p-calendar>
        </div>

        <div class="col-12 col-md-3 col-xl-2">
          <label
            class="form-label text-secondary fw-500"
            style="font-size: calc(0.65rem + 0.45vh);">
            Hasta
          </label>
          <p-calendar
            [(ngModel)]="filterEndDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [showClear]="true"
            placeholder="Fecha fin"
            styleClass="w-100">
          </p-calendar>
        </div>

        <div class="col-12 col-md-auto">
          <button
            (click)="search()"
            type="button"
            [disabled]="externalServiceLogService.loading"
            class="btn btn-primary d-flex align-items-center gap-1">
            <i class="material-icons"
              style="font-size: 1.1rem;">
              search
            </i>
            Buscar
          </button>
        </div>

      </div>
    </div>

    <!-- Tabla -->
    <div class="col-12">
      <p-table
        #dt
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        [filterDelay]="0"
        [first]="first"
        [lazy]="true"
        [loading]="externalServiceLogService.loading"
        [paginator]="true"
        [rowHover]="true"
        [rows]="25"
        [rowsPerPageOptions]="[25, 50, 100]"
        [showCurrentPageReport]="true"
        [totalRecords]="externalServiceLogService.total"
        [value]="externalServiceLogService.logs"
        (onLazyLoad)="onLazyLoad($event)">

        <ng-template pTemplate="caption">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col">
                Registros de servicios externos
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th style="min-width: 140px;">Fecha</th>
            <th>Servicio</th>
            <th>Dirección</th>
            <th>Método</th>
            <th style="min-width: 200px;">URL</th>
            <th>Status</th>
            <th></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-log>
          <tr class="p-selectable-row">

            <td>
              <span class="p-column-title">Fecha</span>
              {{ log.createdAt | dateToMoment: 'DD/MM/YYYY HH:mm' }}
            </td>

            <td>
              <span class="p-column-title">Servicio</span>
              {{ log.serviceLabel }}
            </td>

            <td>
              <span class="p-column-title">Dirección</span>
              <span
                class="badge rounded-pill"
                [ngClass]="{
                  'text-bg-primary': log.direction === 'outbound',
                  'text-bg-info': log.direction === 'inbound'
                }">
                {{ log.directionLabel }}
              </span>
            </td>

            <td>
              <span class="p-column-title">Método</span>
              <code>{{ log.method }}</code>
            </td>

            <td>
              <span class="p-column-title">URL</span>
              <span
                class="d-inline-block text-truncate"
                style="max-width: 220px; vertical-align: bottom;"
                [title]="log.url">
                {{ log.url }}
              </span>
            </td>

            <td>
              <span class="p-column-title">Status</span>
              <span
                class="badge rounded-pill"
                [ngClass]="log.statusClass">
                {{ log.statusCode ?? '-' }}
              </span>
            </td>

            <td>
              <a
                [routerLink]="[log.externalServiceLogId]"
                class="btn btn-sm btn-light rounded-circle"
                placement="top"
                ngbTooltip="Ver detalle">
                <i class="material-icons mt-1">visibility</i>
              </a>
            </td>

          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td
              colspan="7"
              class="text-center text-secondary py-4">
              No hay registros para los filtros seleccionados
            </td>
          </tr>
        </ng-template>

      </p-table>
    </div>

  </div>
</div>
